import styled from 'styled-components'
import PropTypes from 'prop-types'

import { COLOR } from '../../design/color/color.constants'
import { FONT_SIZE, FONT_BOLD } from '../../design/typography/typography.constants'
import { SPACING } from '../../design/spacing/spacing.constants'

const Button = styled.button`
  ${FONT_BOLD};
  font-size: ${props => props.size === 'large' ? FONT_SIZE.LARGE : FONT_SIZE.MEDIUM};
  line-height: ${props => props.size === 'large' ? FONT_SIZE.LARGE : FONT_SIZE.MEDIUM};
  color: ${({ buttonType, disabled }) => {
    if (disabled) {
      return COLOR.GREY_DARK
    } else if (buttonType === 'primary' || buttonType === 'danger') {
      return COLOR.WHITE
    }
    return COLOR.BLACK
  }};

  background-color: ${({ buttonType, disabled }) => {
    if (disabled) {
      return COLOR.GREY_LIGHTER
    } else if (buttonType === 'primary') {
      return COLOR.BLUE_MEDIUM
    } else if (buttonType === 'danger') {
      return COLOR.RED_MEDIUM
    }
    return COLOR.WHITE
  }};

  padding: ${props => props.size === 'large' ? SPACING.M : SPACING.S};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ buttonType, disabled }) => {
    if (disabled) {
      return COLOR.GREY_LIGHT
    } else if (buttonType === 'primary') {
      return COLOR.BLUE_MEDIUM
    } else if (buttonType === 'danger') {
      return COLOR.RED_MEDIUM
    }
    return COLOR.GREY_LIGHT
  }};

  border-radius: 4px;
  outline: none;
  text-decoration: none;
  ${props => props.disabled ? '' : 'cursor: pointer;'}
  ${props => (props.disabled ? 'pointer-events: none' : '')}
  ${props => props.width && `width: ${props.width};`}

  &:hover {
    background-color: ${({ buttonType, disabled }) => {
    if (disabled) {
      return COLOR.GREY_LIGHTER
    } else if (buttonType === 'primary') {
      return '#007aac'
    } else if (buttonType === 'danger') {
      return '#DD4558'
    }
    return '#ebeded'
  }};
  }

  &:active {
    box-shadow: inset 0 1px 4px 0 ${props => props.buttonType === 'primary' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 18, 26, 0.1)'};
  }
`

Button.displayName = 'Button'

Button.propTypes = {
  buttonType: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  dataTestid: PropTypes.string,
}

Button.defaultProps = {
  buttonType: 'primary',
  size: 'small',
}

export { Button }
